import ModuleWrapper from 'shared-lib/containers/Module';

const Offers = () => import(/* webpackChunkName: "offers" */ '@/views/offers/Offers');
const OfferDetails = () => import(/* webpackChunkName: "offer-details" */ '@/views/offers/OfferDetails');
const AddOffer = () => import(/* webpackChunkName: "offer-add" */ '@/views/offers/AddOffer');
const EditOffer = () => import(/* webpackChunkName: "offer-edit" */ '@/views/offers/EditOffer');
const CloneOffer = () => import(/* webpackChunkName: "offer-clone" */ '@/views/offers/CloneOffer');
const OfferTrafficSources = () => import(/* webpackChunkName: "traffic-sources" */ '@/views/offers/OfferTrafficSources');
const meta = (data = {}) => ({
    permissionsModuleName: 'offers',
    auth: true,
    ...data,
});

const Applications = () => import(/* webpackChunkName: "applications" */ '@/views/applications/Applications');
const ApplicationDetails = () => import(/* webpackChunkName: "application-details" */ '@/views/applications/ApplicationDetails');
const AddApplication = () => import(/* webpackChunkName: "add-application" */ '@/views/applications/AddApplication');
const EditApplication = () => import(/* webpackChunkName: "edit-application" */ '@/views/applications/EditApplication');
const applicationsMeta = (data = {}) => ({
    privilegeModule: 'applications',
    auth: true,
    ...data,
});

export default [{
    path: 'offers',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
        title: 'Offers',
    }),
    children: [
        {
            path: '',
            name: 'Offers',
            component: Offers,
            props: true,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: ':offerId(\\d+)/edit',
            name: 'EditOffer',
            component: EditOffer,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: 'add',
            name: 'AddOffer',
            component: AddOffer,
            props: true,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':offerId(\\d+)/clone',
            name: 'CloneOffer',
            component: CloneOffer,
            props: true,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':offerId(\\d+)/traffic-sources',
            name: 'OfferTrafficSources',
            component: OfferTrafficSources,
            props: true,
        },
        {
            path: ':offerId(\\d+)',
            name: 'OfferDetails',
            component: OfferDetails,
            props: true,
            meta: meta({
                permission: 'list',
            }),
        },

        // Applications
        {
            path: 'applications',
            name: 'Applications',
            component: Applications,
            props: true,
            meta: applicationsMeta({
                permission: 'list',
            }),
        },
        {
            path: 'applications/:id(\\d+)',
            name: 'ApplicationDetails',
            component: ApplicationDetails,
            props: true,
            meta: applicationsMeta({
                permission: 'read',
            }),
        },
        {
            path: 'applications/add',
            name: 'AddApplication',
            component: AddApplication,
            props: true,
            meta: applicationsMeta({
                permission: 'create',
            }),
        },
        {
            path: 'applications/:id(\\d+)/edit',
            name: 'EditApplication',
            component: EditApplication,
            props: true,
            meta: applicationsMeta({
                permission: 'update',
            }),
        },
    ],
}];
